module.exports = __webpack_public_path__ + "img/sv73.95348bcf.svg";